import cs from './cs'
import Utils from '../Utils'

var csMsg = {
  'agreements.title': 'Smlouvy',
  'agreements.error.mandatory': "Abyste mohli nadále používat služby deeper, musíte vyjádřit svůj souhlas.",
  'agreements.error.blank': "Vyberte jednu z možností.",
  'agreements.back': 'Zpět',
  'agreements.agree': 'Souhlasím',
  'agreements.decline': 'Nesouhlasím',
  'agreements.text.full': 'Úplná smlouva'
}

Utils.addTerms(csMsg, cs)

export default csMsg



// WEBPACK FOOTER //
// ./src/lang/csMsg.js